import styled from "styled-components";

const IconCancel = styled.img.attrs({
  src: "/assets/images/cancel-icon.png",
  alt: "Cancel Change State",
  title: "Cancel Change State"
})`
  cursor: pointer;
  height: 12px;
  padding-left:5px;
`;
IconCancel.displayName = "CancelChange";

export default IconCancel;
